<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Select from '$components/Form/Select.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const projectTypeOptions = [
        `Aménagement foncier`,
        `Achat de terrain`,
        `Construction de maison`,
        `Gestion immobilière`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const geographicLocationOptions = [
        `Zone urbaine`,
        `Zone rurale`,
        `Autre (veuillez préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const specificServicesOptions = [
        `Lotissement`,
        `Viabilisation de terrains`,
        `Topographie`,
        `Assainissement`,
        `Forage`,
        `Electrification rurale`,
        `Autre (veuillez préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.amenagementFoncier.projectType}
        class=""
        let:field
        let:id
        label={`Quel type de projet foncier ou immobilier envisagez-vous ?`}
    >
        <Select
            {form}
            {field}
            {id}
            required={false}
            options={projectTypeOptions}
            placeholder="Sélectionnez un type de projet"
        />
    </Row>

    <Row
        {form}
        field={fields.amenagementFoncier.geographicLocation}
        class=""
        let:field
        let:id
        label={`Quelle est la localisation géographique de votre projet ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={geographicLocationOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.amenagementFoncier.specificServices}
        class=""
        let:field
        let:id
        label={`Quels services spécifiques recherchez-vous pour votre projet ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={specificServicesOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
